<template>
  <el-dialog
    title="系统状态"
    class="musicbox-status-wrap"
    :visible="true"
    width="70%"
    :before-close="close"
  >
    <el-tabs v-model="activeName" type="card" v-loading="loading" v-bind="loadingConfig">
      <el-tab-pane v-for="tab in tabs" :label="tab.label" :name="tab.name" :key="tab.name">
        <div
          class="tab-content"
          v-if="activeName === tab.name"
          v-loading="activeName === 'statusInfo' && statusLoading"
          v-bind="loadingConfig"
        >
          <el-table :data="tab.data" border height="500px" max-height="500px">
            <template v-for="col in tab.thead">
              <CustomColumn :col="col" :key="col.code" />
            </template>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="action-wrap" v-if="['ticInfo', 'cwaInfo'].includes(activeName)">
      <el-button @click="reset" :loading="loading">恢复默认</el-button>
      <el-button type="primary" @click="save" :loading="saveLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CustomColumn from './components/custom-column.vue';
import { getDeviceStatus, paramSetting } from '@/api/deviceSetting';
import {
  baseInfoHandler,
  ticInfoHandler,
  cwaInfoHandler,
  statusInfoHandler,
  makeThresholdCols,
  makeParams
} from './utils';

export default {
  components: {
    CustomColumn
  },
  props: {
    sn: String,
    deviceType: String
  },
  sockets: {
    /** 设备详细信息 更新连接状态信息 */
    '/socket/detail'(res) {
      if (this.sn !== res.sn) return;
      this.statusInfo.data.splice(0, Infinity, ...statusInfoHandler(res));
      this.statusLoading = false;
    }
  },
  data() {
    return {
      activeName: 'baseInfo',
      loading: true,
      statusLoading: true,
      saveLoading: false,
      loadingConfig: {
        'element-loading-text': '拼命加载中',
        'element-loading-spinner': 'el-icon-loading',
        'element-loading-background': 'rgba(0, 0, 0, 0.8)'
      },
      baseInfo: {
        label: '设备基本信息',
        name: 'baseInfo',
        data: [],
        thead: [
          { label: '项目名称', prop: 'name' },
          { label: '项目值', prop: 'value' }
        ]
      },
      ticInfo: {
        label: 'TIC传感器',
        name: 'ticInfo',
        data: [],
        thead: [
          { label: '传感器名称', prop: 'sensorName', width: '120px', fixed: true },
          { label: '版本', prop: 'version' },
          { label: '量程', prop: 'fullScale' },
          { label: '序列号', prop: 'sensorSn' },
          { label: '单位', prop: 'unit', width: '120px', editable: true, type: 'dropdown' },
          {
            label: '报警阈值',
            prop: 'currentThreshold',
            child: makeThresholdCols()
          },
          {
            label: '默认报警阈值(工作场景)',
            prop: 'workThreshold',
            child: makeThresholdCols()
          },
          {
            label: '默认报警阈值(公共场景)',
            prop: 'commonThreshold',
            child: makeThresholdCols()
          }
        ]
      },
      cwaInfo: {
        label: 'CWA传感器',
        name: 'cwaInfo',
        data: [],
        thead: [
          { label: '传感器名称', prop: 'sensorName' },
          { label: '版本', prop: 'version' },
          { label: '量程', prop: 'fullScale' },
          { label: '序列号', prop: 'sensorSn' },
          { label: '单位', prop: 'unit', editable: true, type: 'dropdown' },
          { label: '报警阈值', prop: 'currentThreshold', editable: true },
          { label: '默认报警阈值(工作场景)', prop: 'workThreshold', editable: true },
          { label: '默认报警阈值(公共场景)', prop: 'commonThreshold', editable: true }
        ]
      },
      statusInfo: {
        label: '连接状态',
        name: 'statusInfo',
        data: [],
        thead: [
          { label: '项目名称', prop: 'name' },
          { label: '项目值', prop: 'value' }
        ]
      }
    };
  },
  computed: {
    tabs() {
      const { baseInfo, ticInfo, cwaInfo, statusInfo } = this;
      return [baseInfo, ticInfo, cwaInfo, statusInfo];
    }
  },
  methods: {
    /** 获取设备状态
     * @param {1|2} busiType 业务类型：1 获取参数 2 恢复默认参数
     */
    getDeviceStatus(busiType = 1) {
      getDeviceStatus({ sn: this.sn, deviceType: this.deviceType, busiType })
        .then(res => {
          this.upInfo(res);
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    upInfo(res) {
      if (!res || !res.data) return;
      this.baseInfo.data.splice(0, Infinity, ...baseInfoHandler(res));
      this.ticInfo.data.splice(0, Infinity, ...ticInfoHandler(res));
      this.cwaInfo.data.splice(0, Infinity, ...cwaInfoHandler(res));
    },
    destroy() {
      document.querySelector('.musicbox-status-wrap').remove();
      this.$destroy();
    },
    close() {
      this.destroy();
    },
    reset() {
      this.loading = true;
      this.baseInfo.data.splice(0);
      this.ticInfo.data.splice(0);
      this.cwaInfo.data.splice(0);
      this.getDeviceStatus(2);
    },
    save() {
      this.saveLoading = true;
      paramSetting({
        sn: this.sn,
        deviceType: this.deviceType,
        requestData: makeParams(this.activeName, this)
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '保存成功'
          });
        })
        .finally(() => {
          this.saveLoading = false;
        });
    }
  },
  created() {
    this.getDeviceStatus();
  }
};
</script>

<style lang="scss">
.musicbox-status-wrap {
  @import url('~@/assets/css/theme2/dialog.css');
  @import url('~@/assets/css/theme2/tabs.css');
  @import url('~@/assets/css/theme2/table.css');
  .action-wrap {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
